import script from "./PortfolioCard.vue?vue&type=script&setup=true&lang=js"
export * from "./PortfolioCard.vue?vue&type=script&setup=true&lang=js"

import "./PortfolioCard.vue?vue&type=style&index=0&id=6c9e3896&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6c9e3896"]])

export default __exports__